<template>
  <div v-if="termsAccepted" class="page-container">
    <div class="footer-container">
      <div class="row footer">
        <div
          class="col-xs-12 col-md-6 order-2 order-md-0 text-md-start policy-font"
        >
          <span
            >{{ year }} © {{ $t("made_by") }}
            <a href="https://sentice.com/" target="_blank">Sentice</a
            ><i> {{ $t("version") }}: 2 Alpha</i></span
          >
        </div>

        <div
          class="col-xs-12 col-md-6 order-1 order-md-0 text-md-end policy-font"
        >
          <router-link to="/cookie-policy" target="_blank">{{
            $t("cookie_policy")
          }}</router-link>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <router-link to="/privacy-policy" target="_blank">{{
            $t("privacy_policy")
          }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: ["position"],
  data() {
    return {
      year: "",
    };
  },
  computed: {
    termsAccepted() {
      return this.$store.getters.termsAndConditionsAccepted;
    },
  },
  created() {
    this.year = new Date().getFullYear();
    //console.log(this.year);
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables";
@import "../assets/scss/_mixins";
.page-container {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
}

.footer-container {
  margin-top: auto;
}
.footer {
  max-width: 1900px;
  margin-left: auto;
  margin-right: auto;

  width: 100%;
  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;

  margin-top: 2px;
  font-size: 14px;

  a {
    font-weight: bold;
    text-decoration: none;
    color: $main-text-color;
  }

  a:hover {
    color: $text-color-purple;
  }

  span {
    color: $main-text-color;
  }
}
@media (max-width: 933px) {
  .footer {
    margin-bottom: 30px;
    padding: 0 12px;
    border-radius: 0;
    text-align: center;
    .policy-font {
      font-size: 11px;
    }
  }
}
@media (max-width: 768px) {
  .footer {
    margin-bottom: 30px;
    padding: 0 12px;
    border-radius: 0;
    text-align: center;
    .policy-font {
      font-size: 10px;
    }
  }
}
@media (max-width: 320px) {
  .footer {
    margin-bottom: 30px;
    padding: 0 12px;
    border-radius: 0;
    text-align: center;
    .policy-font {
      font-size: 9px;
    }
  }
}
</style>
